import React, { useEffect, useState } from "react";
import { useLoader } from "../context/LoaderContext";
import { IFacultyMembersData } from "../exports/interfaces";
import { dynamicFailed } from "../hooks/custom/useToast";
import Banner from "../components/Banner";
import { fetchFacultyMembersBanner } from "../api/BannerApi";
import { fetchInternationalVisitingFaculties } from "../api/FacultyMembersApi";
import FacultyMembers from "../components/faculty-members/FacultyMembers";

const FacultyMembersPage = () => {
  const { setLoading } = useLoader();
  const [internationalVisitingFaculties, setInternationalVisitingFaculties] =
    useState<IFacultyMembersData[]>([]);
  const [facultiesMembersBanner, setFacultiesMembersBanner] = useState<
    IFacultyMembersData[]
  >([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    Promise.all([
      fetchInternationalVisitingFaculties(),
      fetchFacultyMembersBanner(),
    ])
      .then(
        ([internationalVisitingFacultiesData, facultiesMembersBannerData]) => {
          setInternationalVisitingFaculties(internationalVisitingFacultiesData);
          setFacultiesMembersBanner(facultiesMembersBannerData);
        },
      )
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      })
      .finally(() => {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      });
  }, [setLoading]);
  return (
    <>
      <Banner
        title="Faq"
        bannerImage={facultiesMembersBanner?.[0]?.image?.[0]}
      />
      <FacultyMembers
        internationalVisitingFaculties={internationalVisitingFaculties}
      />
    </>
  );
};

export default FacultyMembersPage;
